// extracted by mini-css-extract-plugin
export default {"hideTooltip":"G8-z","fadeIn":"H8-z","delay":"I8-z","recommendedSizeTooltip":"J8-z"};